import React, { BaseSyntheticEvent, useState } from 'react';
import { deleteAlgorithm, AlgorithmWithId } from '../../api/studykit';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@dls/react-core';
import { KeyedMutator } from 'swr/dist/types';
import { useSnackbar } from 'notistack';
import { NotiStackAction } from '../styled/notistack-action';
import {
  StyledDialogHeading,
  StyledDialogIconContainer,
  StyledDialogTitleForIcon,
} from '../styled/styles';
import { Icon } from '@dls/react-icon';
import { ColorX11 } from '../../styling/color';
import { ServerValidationError } from '../../api/axios';

interface RemoveAlgorithmDialogProps {
  algorithm: AlgorithmWithId;
  open: boolean;
  onClose: () => void;
  mutate: KeyedMutator<any>;
}

export const RemoveAlgorithmDialog: React.FC<RemoveAlgorithmDialogProps> = ({
  algorithm,
  open,
  onClose,
  mutate,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit = (e: BaseSyntheticEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    deleteAlgorithm(algorithm.id)
      .then(() => mutate())
      .then(() => {
        enqueueSnackbar(`${algorithm.name} successfully deleted!`, {
          variant: 'success',
          action: <NotiStackAction close={closeSnackbar} />,
        });
        onClose();
      })
      .catch((error) => {
        let message = `Error deleting ${algorithm.name}!`;
        if (error instanceof ServerValidationError) {
          message = error.message;
        }
        enqueueSnackbar(message, {
          variant: 'error',
          action: <NotiStackAction close={closeSnackbar} />,
        });
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <StyledDialogTitleForIcon disableTypography>
        <StyledDialogIconContainer>
          <Icon name={'DeleteTrash'} size={'m'} color={ColorX11.Black} />
        </StyledDialogIconContainer>
        <StyledDialogHeading variant={'h3'}>Are you sure?</StyledDialogHeading>
      </StyledDialogTitleForIcon>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove the following algorithm?
          <br /> <br />
          {algorithm.name}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <form onSubmit={onSubmit}>
          <Button
            disabled={isSubmitting}
            type={'button'}
            onClick={onClose}
            dls_variant={'quietEmphasis'}
          >
            Cancel
          </Button>
          <Button
            disabled={isSubmitting}
            style={{ marginLeft: `8px` }}
            type={'submit'}
            dls_variant={'signalError'}
          >
            Delete
          </Button>
        </form>
      </DialogActions>
    </Dialog>
  );
};
